import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FileManagerService} from '../../services/file-manager.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Location} from '@angular/common';
import {TranslateService} from '@ngx-translate/core';
import {FileObject} from '../../classes/folder';

@Component({
    selector: 'ftm-file-manager-container',
    templateUrl: './file-manager-container.component.html',
    styleUrls: ['./file-manager-container.component.scss']
})
export class FileManagerContainerComponent implements OnInit, OnDestroy {
    currentFolder: FileObject;
    busy: Subscription;
    subscription: Subscription;
    public files: File[] = [];
    private readonly uploadError: string;

    constructor(private _fmService: FileManagerService,
                private _translate: TranslateService,
                private _snackBar: MatSnackBar,
                private _route: ActivatedRoute,
                private _router: Router,
                private _location: Location) {
        this.uploadError = this._translate.instant('file_manager.upload_file_error');
    }

    public trackByFn = (i, item) => item;

    ngOnInit() {

        this.subscription = this._route.queryParams
            .subscribe(params => {
                this.busy = this._fmService.read(params.path ? params.path : 'root', params.folder ? params.folder === 'true' : true)
                    .subscribe(
                        (data) => {
                            this.currentFolder = data;
                        },
                        err => {
                            this.showSnackBar(err);
                            this._location.back();
                        },
                    );
            });

    }

    search(term: string): void {
        if (term.length > 2) {
            this._fmService.search(this.currentFolder.path === '/' ? this.currentFolder.path : `${this.currentFolder.path}/`, term)
                .subscribe(
                    suc => {
                        this.currentFolder.children = suc.results;
                    },
                    err => this._fmService.changeUrl()
                );
        } else if (term === '') this._fmService.changeUrl();
    }

    addFile() {
        this._fmService.create(this.currentFolder.path)
            .subscribe(
                () => this._fmService.changeUrl(),
                err => err.error ? this.showSnackBar(err) : null
            );
    }

    uploadFiles(files: File[]) {
        if (this.currentFolder.permissions.w) {
            this._fmService.upload(this.currentFolder.path, files).subscribe(
                () => this._fmService.changeUrl(),
                err => this.showSnackBar(err)
            );
            this.files = [];
        }
    }

    showSnackBar(err) {
        this._snackBar.open(this._translate.instant(`file_manager.${err.error.description}`));
    }

    handlePath(name) {
        const queryParams = this.currentFolder.prepareQueryParams(name);
        if (queryParams) this._router.navigate(this._fmService.rootUrl, {queryParams}).then();
    }

    goToParent() {
        return this._router.navigate(this._fmService.rootUrl, {queryParams: {path: btoa(this.currentFolder.dir)}});
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
